
/*
 *   File : download-button.js
 *   Author : https://evoqins.com
 *   Description : Download button
 *   Integrations : NA
 *   Version : 1.0.0
*/

/* import styles */
import styles from '../../Styles/Components/download.module.scss';
import Icon from '../Icon/icon';

const DownloadButton = (props) => {
    const buttonStyleClass = props.loader
        ? styles.e_download_loader
        : props.icon
            ? styles.e_download_btn_with_icon
            : styles.e_download_btn;

    return (
        <button className={`position-relative d-flex ${props.disabled ? styles.e_disabled_btn : ''} ${buttonStyleClass} ${props.className} e-poppins-regular e-font-14 line-height-24px border-radius-6px border-all border-bright-gray justify-content-center align-items-center gap-8px w-max-content color-outer-space bg-white `}
            id={props.id}
            name={props.name}
            data-bs-dismiss={props.cancel}
            data-bs-toggle={props.toggle}
            data-bs-target={props.target}
            type={props.type}
            onClick={props.onPress}>
            {props.loader ? (
                <>
                    <span className={styles.e_loader_ring_inline} />
                    {props.loadingLabel}
                </>
            ) : (
                <>
                    {
                        props.icon &&
                        <Icon icon={props.icon}
                            size={18} />
                    }
                    {props.label}
                </>
            )}
        </button>
    )
}
DownloadButton.defaultProps = {
    onPress: () => { },
    className: '',
    cancel: null,
    toggle: null,
    target: null,
    type: '',
    id: null,
    name: "",
    label: "Download",
    loadingLabel: "Downloading...",
    icon: null,
}
export default DownloadButton;

